$(function() {
  /*
  var clonedDiv = $(".filters").clone(true);
  

  $(window).on('load resize', function(){
    if (window.matchMedia( "(min-width: 768px)" ).matches) {
      if($('.continar_left .filters').length){
      }
      else{
        clonedDiv.appendTo(".continar_left");
      }
    }
    else{
      $(".continar_left").empty();
    }
  });*/
	/*$('.filters-adjacent .product-block .image-cont').matchHeight();*/
	$('.filters-adjacent .product-block .product-block__title').matchHeight();
	$('.filters-adjacent .product-block .product-block__no').matchHeight();
	$('.filters-adjacent .product-block .product-price').matchHeight();
	$('.filters-adjacent .product-block .innerer .product-link').matchHeight();
	$('.layout-switch-btn').click(function(){
      
      setTimeout(function(){
    		/*$('.filters-adjacent .product-block .image-cont').matchHeight();*/
    		$('.filters-adjacent .product-block .product-block__title').matchHeight();
    		$('.filters-adjacent .product-block .product-block__no').matchHeight();
    		$('.filters-adjacent .product-block .product-price').matchHeight();
    		$('.filters-adjacent .product-block .innerer .product-link').matchHeight();
      },100);          
      
	});	
	$('.layout-switch--one-column').click(function(){
		$('.layout-switch--two-columns').removeClass("layout-switch--active");
		$('.layout-switch--one-column').addClass("layout-switch--active");
		$('.product-grid').removeClass("product-grid--per-row-mob-1");
        $('.product-grid').addClass("product-grid--per-row-mob-2");
      return false;
	});	
	$('.layout-switch--two-columns').click(function(){
		$('.layout-switch--one-column').removeClass("layout-switch--active");
        $('.layout-switch--two-columns').addClass("layout-switch--active");
		$('.product-grid').removeClass("product-grid--per-row-mob-2");
		$('.product-grid').addClass("product-grid--per-row-mob-1");
		return false;
		
	});	
});